import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;
@Injectable({
  providedIn: 'root'
})
export class FooterService {

  protected urlBase = environment.url_server;

  constructor(private httpService: HttpService) { }


  buscaWhatsApp(data: any, successHandle: Function, errorHandle: Function) {

     this.httpService.doGet('/whatsApp', data, successHandle, errorHandle);

  }

 

}
